/**
 * HTTP layer for inventory locations. The physical or logical locations that
 * hold radio inventory.
 *
 * Contains:
 * - fetchInventoryLocations / fetchInventoryLocation: reads
 * - postInventoryLocation / patchInventoryLocation / deleteInventoryLocation: writes
 */
import apiClient from '@sophocles/http-common';

const INVENTORY_LOCATION_ENDPOINT = '/inventory/locations';

export const fetchInventoryLocations = queryParams =>
  apiClient.get(`${INVENTORY_LOCATION_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchInventoryLocation = inventoryLocationId =>
  apiClient.get(`${INVENTORY_LOCATION_ENDPOINT}/${inventoryLocationId}/`).then(res => res.data);

export const postInventoryLocation = data =>
  apiClient.post(`${INVENTORY_LOCATION_ENDPOINT}/`, data).then(res => res.data);

export const patchInventoryLocation = (inventoryLocationId, data) =>
  apiClient.patch(`${INVENTORY_LOCATION_ENDPOINT}/${inventoryLocationId}/`, data).then(res => res.data);

export const deleteInventoryLocation = inventoryLocationId =>
  apiClient.delete(`${INVENTORY_LOCATION_ENDPOINT}/${inventoryLocationId}/`);
